import React, { useEffect, useRef, useState } from "react";
import DataTable from "react-data-table-component";
import { Card, CardBody } from "reactstrap";
import { useDispatch } from "react-redux";
import { chipLogs } from "../../../../../store/slices/APIResponseSlice";
import AirHomeLoader from "../../../../../components/Common/AirHomeLoader";
import { RefreshBtn } from "../../../../../components/Common/button";
import Request from "../../../../../helpers/request";
interface InterfaceDataTable {
  apiURL: string;
  title?: string;
  isReload?: boolean;
  columns: any[];
  selectedRoomID?: any[];
  ExpandedComponent?: any;
  customStyles: any;
  ExpandCollapseIcon: any;
  idName: string;
  loading: boolean;
  setLoading: (loading: boolean) => void;
  selectedRows: any;
  setSelectedRows: any;
  handlePingAll?: () => void;
  handleDsAll?: () => void;
  handleDeleteAll?: () => void;
  handleOtaAll?: () => void;
  handleBSCHAll?: () => void;
  handleBinding?: () => void;
  userId: any;
  selectedPremise?: any;
  expandableRows: boolean;
  setChipData?: any;
  showBindingButton?:any;
}

function ChipsDataTable({
  userId,
  selectedPremise,
  apiURL,
  expandableRows,
  title,
  selectedRoomID,
  isReload,
  columns,
  ExpandedComponent,
  customStyles,
  ExpandCollapseIcon,
  idName,
  loading,
  setLoading,
  selectedRows,
  setSelectedRows,
  handlePingAll,
  handleDsAll,
  handleDeleteAll,
  handleOtaAll,
  handleBSCHAll,
  handleBinding,
  setChipData,
  showBindingButton,
}: InterfaceDataTable) {
  const dispatch = useDispatch();

  const [data, setData] = useState<any[]>([]);
  const [totalRows, setTotalRows] = useState<number>(0);
  const [page, setPage] = useState<number>(1);
  const [perPage, setPerPage] = useState<number>(10);
  const [searchText, setSearchText] = useState<string>("");
  const isFetchingRef = useRef<boolean>(false);

  const fetchData = async (
    page: number,
    perPage: number,
    searchValue: string,
  ) => {
    setLoading(true);
    if (isFetchingRef.current) {
      return;
    }
    isFetchingRef.current = true;

    try {
      const reqObj = {
        draw: 1,
        order: [],
        start: (page - 1) * perPage,
        length: perPage,
        search: {
          value: searchValue,
          regex: false,
        },
        ...(idName === "Driverlist" && { type: "airDriver" }),
        userId: userId,
        ...(selectedPremise ? { premiseId: selectedPremise.id } : {}),
        roomId:
          selectedRoomID
            ?.filter((item: any) => item.isChecked)
            .map((item: any) => item.id)
            .join(",") || "",
      };

      const response = await Request.post(apiURL, reqObj);

      setData(response.data.data || []);
      setTotalRows(response.data.recordsTotal || 0);
      if (idName === "Chiplist") {
        setChipData(response.data.data || []);
      }

      if (idName === "Chiplist" || idName === "Blasterlist") {
        dispatch(
          chipLogs({
            totalOfflineTime: response.data?.totalOfflineTime,
            totalOnlineTime: response.data?.totalOnlineTime,
          }),
        );
      }
    } catch (error: any) {
      console.error("Error fetching data:", error);
      if (error.response && error.response.status === 401) {
        // window.localStorage.clear();
        localStorage.removeItem("userInfo");
        localStorage.removeItem("selectedPremiseID");
        localStorage.removeItem("selectedUserID");
        localStorage.removeItem("selectedUserEmail");
        localStorage.removeItem("Authorization");
        localStorage.removeItem("permissions");
        window.location.reload();
      }
    } finally {
      setLoading(false);
      isFetchingRef.current = false;
    }
  };

  useEffect(() => {
    fetchData(page, perPage, searchText);
  }, [page, perPage, searchText, apiURL, selectedRoomID, isReload]);

  const handlePageChange = (newPage: number) => setPage(newPage);

  const handlePerRowsChange = (newPerPage: number, newPage: number) => {
    setPerPage(newPerPage);
    setPage(newPage);
  };

  const handleSearch = (e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
    setPage(1);
  };

  const handleSelectedRowsChange = ({
    selectedRows,
  }: {
    selectedRows: any[];
  }) => {
    setSelectedRows(selectedRows);
  };
  const handleReload = () => {
    fetchData(page, perPage, searchText);
  };

  return (
    <Card>
      <CardBody>
        <div className="">
          <DataTable
            columns={columns}
            data={data}
            pagination
            paginationServer
            paginationTotalRows={totalRows}
            onChangePage={handlePageChange}
            onChangeRowsPerPage={handlePerRowsChange}
            highlightOnHover
            customStyles={customStyles}
            selectableRows
            onSelectedRowsChange={handleSelectedRowsChange}
            {...(expandableRows && {
              expandableRows: true,
              expandableRowsComponent: ExpandedComponent,
              expandableIcon: {
                collapsed: <ExpandCollapseIcon expanded={false} />,
                expanded: <ExpandCollapseIcon expanded={true} />,
              },
            })}
            paginationRowsPerPageOptions={[10, 25, 50, 100]}
            subHeader
            subHeaderComponent={
              <div className="container-fluid p-0 pb-2">
                <div className="row gx-2 gy-2 align-items-center">
                  <div className="col-12 col-md-6 d-flex flex-wrap align-items-center gap-2">
                    <h5 className="m-0 fw-bold" style={{ fontSize: "18px" }}>
                      {title || "Data Table"}
                    </h5>
                    {selectedRows.length > 0 && (
                      <div
                        className="fw-bold text-dark bg-light px-2 py-1 rounded fade show"
                        style={{
                          fontSize: "12px",
                          transition: "opacity 0.3s ease-in-out",
                          lineHeight: "1.2",
                        }}
                      >
                        {selectedRows.length}{" "}
                        {selectedRows.length === 1 ? "item" : "items"} selected
                      </div>
                    )}
                    {showBindingButton && idName === "Chiplist" && (
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleBinding && handleBinding()}
                      >
                        Device Binding
                      </button>
                    )}
                  </div>

                  {/* Search and Action Buttons */}
                  <div className="col-12 col-md-6 d-flex flex-wrap justify-content-md-end align-items-center gap-2">
                    {/* Search Input */}

                    {(idName === "Chiplist" ||
                      idName === "Curtainlist" ||
                      idName === "Blasterlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => handleOtaAll && handleOtaAll()}
                        >
                          OTA
                        </button>
                      )}
                    {(idName === "Chiplist" ||
                      idName === "Blasterlist" ||
                      idName === "Locklist" ||
                      idName === "Driverlist" ||
                      idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-outline-dark btn-sm"
                          onClick={() => handleDeleteAll && handleDeleteAll()}
                        >
                          Delete
                        </button>
                      )}
                    {(idName === "Chiplist" || idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => handleDsAll && handleDsAll()}
                        >
                          DS
                        </button>
                      )}
                    {(idName === "Chiplist" || idName === "Curtainlist") &&
                      selectedRows.length > 0 && (
                        <button
                          className="btn btn-dark btn-sm"
                          onClick={() => handlePingAll && handlePingAll()}
                        >
                          Ping
                        </button>
                      )}
                    {idName === "Blasterlist" && selectedRows.length > 0 && (
                      <button
                        className="btn btn-dark btn-sm"
                        onClick={() => handleBSCHAll && handleBSCHAll()}
                      >
                        BSCH
                      </button>
                    )}
                    <input
                      type="text"
                      placeholder="Search..."
                      className="form-control form-control-sm"
                      style={{ maxWidth: "150px" }}
                      value={searchText}
                      onChange={handleSearch}
                    />
                    <RefreshBtn onClick={handleReload} loading={loading} />
                  </div>
                </div>
              </div>
            }
          />
        </div>
        {loading && <AirHomeLoader />}
      </CardBody>
    </Card>
  );
}

export default ChipsDataTable;
